import React, { useState } from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import { useClientSettingsQuery, IntegratedSystemType } from '../../api/useClientSettingsQuery';
import { Wrapper } from '../../../CommonComponents/OPL/Wrapper/Wrapper';
import { MarginProps } from '../../../theme/styledProps';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { IconButton } from '../../../CommonComponents/OPL/IconButton/IconButton';
import { Tooltip } from '../../../CommonComponents/OPL/Tooltip/Tooltip';
import { useCanUnlinkOrionConsumerQuery } from '../../../ClientSettings/api/useCanUnlinkOrionConsumerQuery';
import { UnlinkAndDeleteModal } from '../../../ClientSettings/components/UnlinkAndDeleteModal/UnlinkAndDeleteModal';

interface Props extends MarginProps {
  clientId: string;
}

export const IntegratedFrom: React.FC<Props> = ({ clientId, ...rest }) => {
  const [isUnlinkModalOpen, setIsUnlinkModalOpen] = useState(false);

  const { data } = useClientSettingsQuery({ clientId });

  const { data: canUnlinkOrionConsumer } = useCanUnlinkOrionConsumerQuery();

  if (!data || !data.integratedSystems) {
    return null;
  }

  return (
    <>
      {isUnlinkModalOpen && <UnlinkAndDeleteModal onClose={() => setIsUnlinkModalOpen(false)} />}

      <Wrapper
        {...rest}
        as="ul"
        mb="0"
        css={`
          list-style: none;
          padding: 0;
        `}
      >
        {data.integratedSystems.map(({ Name: name, Id: id }) => (
          <Box mb="16" as="li" key={id}>
            <Text
              fontWeight={500}
              mb="16"
              as="span"
              id={
                name === IntegratedSystemType.OrionConnect ? 'unlink-icon-button-label' : undefined
              }
            >
              Integrated from {name} with Id {id}
            </Text>

            {canUnlinkOrionConsumer && name === IntegratedSystemType.OrionConnect && (
              <Tooltip content="Unlink" placement="top">
                <IconButton
                  aria-labelledby="unlink-icon-button-label"
                  icon="far fa-link"
                  variant="subtleActive"
                  ml="4"
                  onClick={() => setIsUnlinkModalOpen(true)}
                />
              </Tooltip>
            )}
          </Box>
        ))}
      </Wrapper>
    </>
  );
};
